import * as React from 'react';

export const validateEmail = (email: string): boolean => Boolean(email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i));

export const validateQuestion = (question: string): boolean => {
  const MIN_QUESTION_LENGTH = 15;
  const trimmedQuestion = (question || '') && question.trim();

  return trimmedQuestion.length >= MIN_QUESTION_LENGTH;
};

export const validateName = (name: string): boolean => {
  const trimmedName = (name || '') && name.trim();

  return Boolean(trimmedName);
};

export interface ValidationProps {
  validateName?: (name: string) => boolean;
  validateEmail?: (email: string) => boolean;
  validateQuestion?: (question: string) => boolean;
}

export const withValidation = <P extends object>(WrappedComponent: React.ComponentType<P>) => {
  class ValidationHOC extends React.Component<P & ValidationProps> {
    constructor(props) {
      super(props);
    }

    public render() {
      const validationFunctions = {
        validateName,
        validateEmail,
        validateQuestion
      };

      return <WrappedComponent {...this.props} {...validationFunctions} />;
    }
  }

  (ValidationHOC as any).displayName = `WithValidation(${getDisplayName(WrappedComponent)})`;
  (ValidationHOC as any).wrappedComponent = WrappedComponent;

  return ValidationHOC;
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
